export default __webpack_public_path__ + "static/team-collaborate-672ff4b72b79ef7fceef35eaf50f4e08.svg";